import { catchError, Observable, throwError } from 'rxjs';

import {
    HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpStatusCode
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ErrorService } from '@services/error.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private errorService: ErrorService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        
        if(!error.error.errors) {
            // TODO: handle non-proper error
            this.errorService.showError();
        }
        console.error(error.error);

        // if (error.status !== HttpStatusCode.Unauthorized) {
        //   // TODO: handle error
        //   if (this.errorService.acceptedErrorCodes.includes(error.status)) {
        //     this.errorService.showError();
        //   }
        //   console.error(error.error);
        // }

        return throwError(() => error);
      })
    );
  }
}
